export default "__VITE_ASSET__d974c7ac__"